import axios from './axios'
export default {
  updateMetricStatus: function(campaignId, data) {
    console.log(data)
    return axios.post(
      `/${
        process.env.VUE_APP_API_VERSION
      }/campaigns/${campaignId}/metrics/${data.metric.toLowerCase()}/status`,
      data
    )
  },
  updateCampaignSettings: function(campaignId, data) {
    console.log(data)
    return axios.post(
      `/${
        process.env.VUE_APP_API_VERSION
      }/campaigns/${campaignId}/settings`,
      { data: data }
    )
  },
  updateAppearance: function(campaignId, data) {
    console.log(data)
    return axios.post(
      `/${process.env.VUE_APP_API_VERSION}/campaigns/${campaignId}/appearance`,
      { data: data }
    )
  },
  getQuestions: function(campaignId, type) {
    return axios.get(
      `/${process.env.VUE_APP_API_VERSION}/campaigns/${campaignId}/metrics`,
      { params: { metric_type: type } }
    )
  },
  getTags: function(campaignId) {
    return axios.get(
      `/${process.env.VUE_APP_API_VERSION}/campaigns/${campaignId}/tags`
    )
  },
  addResponseTag: function(campaignId, responseId, tag) {
    return axios.post(
      `/${process.env.VUE_APP_API_VERSION}/campaigns/${campaignId}/responses/${responseId}/tags`,
      { data: { tag: tag } }
    )
  },
  deleteResponseTag: function(campaignId, responseId, tagId) {
    return axios.delete(
      `/${process.env.VUE_APP_API_VERSION}/campaigns/${campaignId}/responses/${responseId}/tags/${tagId}`
    )
  },
  updateTag: function(campaignId, tagId, tag) {
    return axios.post(
      `/${process.env.VUE_APP_API_VERSION}/campaigns/${campaignId}/tags/${tagId}`,
      { tag: tag }
    )
  },
  updateQuestion: function(campaignId, questionId, data) {
    return axios.post(
      `/${process.env.VUE_APP_API_VERSION}/questions/${questionId}`,
      { data: data }
    )
  },
  getAttributes: function(campaignId) {
    return axios.get(
      `/${process.env.VUE_APP_API_VERSION}/campaigns/${campaignId}/attributes`
    )
  },
  getAttributeValues: function(campaignId, attrId, page) {
    return axios.get(
      `/${process.env.VUE_APP_API_VERSION}/campaigns/${campaignId}/attributes/${attrId}`,
      {params: {page: page}}
    )
  },
}
